// Vendors
import $ from 'jquery';
import aa from 'search-insights';

// Data
import {
  ENV,
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY,
  ALGOLIA_INDEX
} from './config';

window.aa = aa('init', {
  appId: ALGOLIA_APP_ID,
  apiKey: ALGOLIA_SEARCH_API_KEY,
  useCookie: true
});
let userToken = '';
aa('getUserToken', null, (err, algoliaUserToken) => {
  userToken = algoliaUserToken;
});

const environment = ENV === 'development' ? 'local' : ENV;

$(document).on('change', '.variation-radios input', function () {
  $('.variation-radios input:checked').each(function (index, element) {
    const $el = $(element);
    const thisName = $el.attr('name');
    const thisVal = $el.attr('value');
    $('select[name="' + thisName + '"]')
      .val(thisVal)
      .trigger('change');
  });
});

// WooCommerce passes the variation object to found_variation before updating the DOM,
// so read the description directly from the event data instead of the DOM.
$(document).on('found_variation', 'form.cart', function (event, variation) {
  const $parsed = $('<div>').html(variation.variation_description);
  const descriptionHtml = $parsed.find('p').html() || $parsed.html();
  updateVariationDescription(descriptionHtml);
});

$(document).on('woocommerce_update_variation_values', function () {
  $('.variation-radios input').each(function (index, element) {
    const $el = $(element);
    const thisName = $el.attr('name');
    const thisVal = $el.attr('value');
    $el.removeAttr('disabled');
    if (
      $(`select[name="${thisName}"] option[value="${thisVal}"]`).is(':disabled')
    ) {
      $el.prop('disabled', true);
    }
  });
});

$('form.cart').on('click', 'button.plus, button.minus', function () {
  // Get current quantity values
  const qty = $(this).closest('form.cart').find('.qty');
  const val = parseFloat(qty.val());
  const max = parseFloat(qty.attr('max'));
  const min = parseFloat(qty.attr('min'));
  const step = parseFloat(qty.attr('step'));

  // Change the value if plus or minus
  if ($(this).is('.plus')) {
    if (max && max <= val) {
      qty.val(max);
    } else {
      qty.val(val + step);
    }
  } else {
    if (min && min >= val) {
      qty.val(min);
    } else if (val > 1) {
      qty.val(val - step);
    }
  }
});

function updateVariationDescription(descriptionHtml) {
  // Fall back to reading DOM when called from window.onload
  let description = descriptionHtml ?? $('.woocommerce-variation-description p').html();
  let variation_descriptions = '';

  // Split Description into Rows
  if (description) {
    const details = description.split('<br>');
    details.forEach(function (detail, index) {
      // Add span before colon
      const line_array = detail.split(':');
      const part1 = '<span>' + line_array[0] + ':</span>';
      const full_line = part1.concat(' ', line_array[1]);
      variation_descriptions = variation_descriptions.concat(
        ' ',
        '<div class="row">' + full_line + '</div>'
      );
    });
  }

  // Add Description Rows back into page
  $('.product-variation-detail .product-variations').html(
    variation_descriptions
  );

  // Show Description
  $('.product-variation-detail').show();
}

window.onload = function () {
  setTimeout(() => {
    updateVariationDescription();
  }, 300);
};

const getQueryID = () => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const queryID = searchParams.get('queryID');
  return queryID;
};

$('form.cart').on(
  'click',
  'button.woocommerce__add-to-cart-btn',
  function (event) {
    // This requires the `search-insights` library
    aa('convertedObjectIDsAfterSearch', {
      userToken: userToken, // required for Node.js
      eventName: 'Product Added To Cart',
      index: ALGOLIA_INDEX.main,
      queryID: getQueryID(),
      objectIDs: ['product#' + $('input[name="product_id"]').val()]
    });
  }
);
